import { findOp, operatorsFor } from './opCatalog'
import { FieldPicker } from './FieldPicker'
import { OpPicker } from './OpPicker'
import { ValueInput } from './ValueInput'
import type { FieldsResponse, PredicateNode, PredicateValue } from './types'

export function RuleCondition({
  metadata, node, onChange, onDelete,
}: {
  metadata: FieldsResponse
  node: Extract<PredicateNode, { type: 'condition' }>
  onChange: (next: PredicateNode) => void
  onDelete: () => void
}) {
  const field = metadata.fields.find(f => f.path === node.field) ?? null
  const op = field ? (findOp(field.type, node.op) ?? null) : null

  return (
    <div className="flex items-center gap-2 py-1">
      <FieldPicker
        fields={metadata.fields}
        value={node.field}
        onChange={path => {
          // pick first valid op for new field type
          const newField = metadata.fields.find(f => f.path === path)
          const newOp = newField ? (operatorsFor(newField.type)[0]?.id ?? '==') : ''
          onChange({ ...node, field: path, op: newOp, value: null })
        }}
      />
      <OpPicker
        field={field}
        value={node.op}
        onChange={opId => onChange({ ...node, op: opId })}
      />
      <ValueInput
        field={field}
        op={op}
        value={node.value}
        onChange={(v: PredicateValue) => onChange({ ...node, value: v })}
        placeholders={metadata.placeholders}
      />
      <button
        type="button"
        onClick={onDelete}
        className="text-xs text-red-600 hover:text-red-800 px-1"
        title="Usuń warunek"
      >×</button>
    </div>
  )
}
